import script from "./LandingPageDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageDesktop.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageDesktop.vue?vue&type=style&index=0&id=ceac5a4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceac5a4c"]])

export default __exports__